import get from 'lodash/get';

export const GA2_ACQ_KPI_NAMES = ['PCI', 'SSB-ARFCN', 'SCS', 'Polarization'];

export const GA2_ACQ_PCI_NAMES = ['RSSI', 'SSB INDEX', 'SSB RSRP', 'SSB RSRQ', 'SSB SINR'];

// sample ga2 beamrank data
// {
//   "azimuth": 45,
//   "elevation": 15,
//   "polarity": "vertical",
//   "power": -65.4,
//   "ssb-arfcn": 123456,
//   "5g-kpis": [
//     {
//       "pci": 1,
//       "issb": 2,
//       "ss-rsrp": -80,
//       "ss-rsrq": -10,
//       "ss-sinr": 20.5,
//       "rssi": -85,
//       "cell-barred": false
//     }
//   ]
// }

export const getGa2PciValue = (beamrank, name, acqData, index, customAzEl = null) => {
  if (!beamrank || !name || index === 0) return 'N/A';

  const selectedBeamrank = beamrank[index - 1];
  
  // Define data source and field mappings based on available data
  let dataSource, fieldMap;
  
  if (selectedBeamrank) {
    dataSource = selectedBeamrank;
    fieldMap = {
      'PCI': 'pci',
      'SSB-ARFCN': 'ssbarfcn',
      'Polarization': 'polarity',
      'RSSI': 'rssi',
      'SSB INDEX': 'ssbIndex',
      'SSB RSRP': 'ssbRsrp',
      'SSB RSRQ': 'ssbRsrq',
      'SSB SINR': 'ssbSinr'
    };
  } else if (customAzEl?.data?.kpiMetrics) {
    dataSource = customAzEl.data.kpiMetrics;
    fieldMap = {
      'PCI': 'pci',
      'SSB-ARFCN': 'ssbarfcn', 
      'Polarization': 'pol', 
      'RSSI': 'rssi',
      'SSB INDEX': 'issb',
      'SSB RSRP': 'ssRsrp',
      'SSB RSRQ': 'ssRsrq',
      'SSB SINR': 'ssSinr'
    };
  } else {
    return 'N/A';
  }

  // Handle special cases
  switch (name) {
    case 'PCI':
      return selectedBeamrank 
      ? get(selectedBeamrank, 'pci', 'N/A')
      : get(customAzEl.data, 'pci', 'N/A');
    case 'SSB-ARFCN':
      const pciValue = selectedBeamrank 
        ? get(selectedBeamrank, 'pci', 'N/A')
        : get(customAzEl.data, 'pci', 'N/A');
      
      if (pciValue === 'N/A') return 'N/A';
      
      return selectedBeamrank 
        ? get(selectedBeamrank, 'ssbarfcn', 'N/A')
        : get(customAzEl.data, 'ssbarfcn', 'N/A');
        
    case 'SCS':
      return get(acqData, 'scs', 'N/A');
      
    case 'Polarization':
      return selectedBeamrank 
        ? get(selectedBeamrank, 'polarity', 'N/A')
        : get(customAzEl.data, 'pol', 'N/A');
        
    default:
      // Handle all other cases using the field mapping
      const fieldName = fieldMap[name];
      return fieldName ? get(dataSource, fieldName, 'N/A') : 'N/A';
  }
};

